/**
 * @desc 保存数据维度配置, 全量更新
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.DimensionConfigureRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/dimension/configure`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
